<!-- main page where all of the components are displayed over -->
<div class="appContainer">
  <!-- nav bar at the top of the page -->
  <app-nav-bar></app-nav-bar>
  <!-- add component here given a specific route -->
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
